module.exports = __webpack_public_path__ + "static/media/caption-3.7e9b2923.jpg";